import gameConfig from "../../../../../../engines/configs/gameConfig";
import { FileKind } from "../../../../../define/FileKind";

/**
 * 
 */
export namespace TouchCardKind {

    export enum GeneralValue {
       
    }

    export class ItemInfo {
        idx: number = 0;
        icon: string = null;
        name: string = null;
        price: number = 0;
        bLock: boolean = false;
        /** 每天购买限制次数 */
        limitCount: number = 0;
        /** 解锁事件id */
        lockEventId: string = null;
        /** 窗口路径 */
        dialogPath?: FileKind.PrefabFileInfo = null;
    }

    export const ItemList: ItemInfo[] = [
        {
            idx: 1
            , icon: 'spr_item_1'
            , name: '摸牌挑战'
            , price: 1000000
            , bLock: false
            , lockEventId: null
            , limitCount: gameConfig.TOUCH_CARD_CHALLENGE_LIMIT
            , dialogPath: FileKind.PrefabFilePath.TouchCardChallengeLayer
        } 
        , {
            idx: 2
            , icon: 'spr_item_2'
            , name: '选牌挑战'
            , price: 5000000
            , bLock: true
            , lockEventId: '13'
            , limitCount: gameConfig.SELECT_CARD_CHALLENGE_LIMIT
            , dialogPath: FileKind.PrefabFilePath.ChooseCardChallengeLayer
        } 
    ];
}

